<div class="orders-options">
	<div class="filter">
		<div class="left">
			<app-select
				[value]="selectedOrderType() ?? null"
				[items]="optionsOrdersTypesConstant"
				(valueChange)="changeOrderType($event)"
			/>

			@if (widget()?.assetClass) {
				<app-asset-type [widget]="widget()" />
			}

			@let activeStatesTables =
				selectedOrderType()?.value === optionOrderTypeEnum.ORDERS ? orderOptionsTables : orderPostTradingTables;
			<div class="tabs">
				@for (order of activeStatesTables; track order) {
					<app-button
						[appearance]="activeOrderType() === order ? 'dark' : 'flat'"
						size="s"
						(clicked)="setOrderType(order)"
					>
						{{ 'optionsOrders.activeOrders.' + order | translate }}
					</app-button>
				}
			</div>
		</div>

		@if (isPostTradingActive()) {
			<app-post-trading-filter
				(datesRange)="onPostTradingDatesRange($event)"
				(searchTicker)="onPostTradingSearchTicker($event)"
			/>
		}
	</div>

	<div class="table">
		@switch (activeOrderType()) {
			@case (optionOrderStateEnum.OPEN) {
				<app-options-opened-orders [widget]="widget()" />
			}
			@case (optionOrderStateEnum.CANCELED) {
				<app-options-canceled-orders [widget]="widget()" />
			}
			@case (optionOrderStateEnum.FILLED) {
				<app-options-executed-orders [widget]="widget()" />
			}
			@case (postTradingEventTypeEnum.EXPIRED) {
				<app-post-trading-expired-orders
					[widget]="widget()"
					[ticker]="postTradingSearchTicker()"
					[datesRange]="postTradingDatesRange()"
				/>
			}
			@case (postTradingEventTypeEnum.EXERCISES) {
				<app-post-trading-exercises-orders
					[widget]="widget()"
					[ticker]="postTradingSearchTicker()"
					[datesRange]="postTradingDatesRange()"
				/>
			}
			@case (postTradingEventTypeEnum.ASSIGNED) {
				<app-post-trading-assigned-orders
					[widget]="widget()"
					[ticker]="postTradingSearchTicker()"
					[datesRange]="postTradingDatesRange()"
				/>
			}
		}
	</div>
</div>
